import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './styles/tokens.css'
import './styles/app.css'
import './styles/topics.css'
import App from './App'
import { initNative } from './native'

// Fired rather than awaited: none of it gates the first paint, and awaiting it would hold a
// blank screen behind three plugin loads that do not exist on the web at all.
void initNative()

createRoot(document.getElementById('root')!).render(
  <StrictMode><App /></StrictMode>,
)
